import Vue from 'vue'
import Vuex from 'vuex'
import userApi from '@/api/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    menus: [],
    menuList: [],
    routePath: '',
    formula: {},
    deviceInfo: null,
    maintainList: [],
    isCollapse: false,
    stationInfo: null,
    visitedViews: [],
    dark: false,
    hiddenTags: [],
    customeTabKey: '',
    warnDeviceFlag: true,
    deviceFlag: false,
    customerFlag: false,
    protocolFlag: true,
    orderFlag: false,
    lang: localStorage.getItem('lang') || 'zh',
    linkageFlag: false,
    clipboard: []
  },
  getters: {
    menus (state) {
      return state.menus
    },
    menuList (state) {
      return state.menuList
    },
    dark(state) {
      return state.dark
    }
  },
  mutations: {
    setClipboard(state, clipboardList) {
      state.clipboard = clipboardList
    },
    setMenu (state, menus) {
      state.menus = menus
    },
    setWarnDeviceFlag(state, key) {
      state.warnDeviceFlag = key
    },
    setOrderFlag(state, flag) {
      state.orderFlag = flag
    },
    setDeviceFlag(state, key) {
      state.deviceFlag = key
    },
    setCustomerFlag(state, key) {
      state.customerFlag = key
    },
    setProtocolFlag(state, key) {
      state.protocolFlag = key
    },
    setLinkageFlag(state, key) {
      state.linkageFlag = key
    },
    setCustomeTabKey (state, key) {
      state.customeTabKey = key
    },
    setMenuList (state, menuList) {
      state.menuList = menuList
    },
    setDark(state, dark) {
      state.dark = dark
    },
    setRoutePath (state, routePath) {
      state.routePath = routePath
    },
    setFormula (state, formula) {
      state.formula = formula
    },
    setDeviceInfo (state, deviceInfo) {
      state.deviceInfo = deviceInfo
    },
    setMaintainList (state, maintainList) {
      state.maintainList = maintainList
    },
    setIsCollapse(state, isCollapse) {
      state.isCollapse = isCollapse
    },
    setStationInfo(state, stationInfo) {
      state.stationInfo = stationInfo
    },
    ADD_VISITED_VIEW: (state, view) => {
      if (state.visitedViews.some(v => v.route === view.route)) return
      const index = state.hiddenTags.findIndex(v => v.route === view.route)
      if (index > -1) {
        state.visitedViews.push(state.hiddenTags.splice(index, 1)[0])
        state.hiddenTags.push(state.visitedViews.shift())
        return
      }
      if (state.visitedViews.length === 8) {
        state.hiddenTags.push(
          state.visitedViews.shift()
        )
        state.visitedViews.push(
          Object.assign({}, view, {
            title: view.name || 'no-name'
          })
        )
      } else {
        state.visitedViews.push(
          Object.assign({}, view, {
            title: view.name || 'no-name'
          })
        )
      }
    },
    DEL_VISITED_VIEW: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.route === view.route) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      if (state.hiddenTags.length) {
        state.visitedViews.push(state.hiddenTags.shift())
      }
    },
    resetHiddenTags(state) {
      state.hiddenTags = []
    },
    DELHIDDENTAG (state, index) {
      state.hiddenTags.splice(index, 1)
    },
    resetTags(state) {
      state.hiddenTags = []
      state.visitedViews = []
    },
    setLang(state, lang) {
      state.lang = lang
    }
  },
  actions: {
    getMenu (context) {
      return userApi.getMenu().then(({ data }) => {
        const menus = data.filter(item => item.flag !== 2).filter(item => item.pid === 0)
        menus.forEach(menu => {
          menu.children = []
          data.forEach(item => {
            if (item.pid === menu.id) {
              menu.children.push(item)
            }
            if(item.id === 33920) {
              item.name = '预警列表'
            }
          })
        })
        return menus
      }).then(menu => {
        context.commit('setMenu', menu)
        return menu
      }).catch(({ message }) => {
        // localStorage.removeItem('token')
      })
    }
  }
})

export default store
